import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { GhostIcon, PumpkinIcon } from './HalloweekLink';
import { useCountdown } from '../hooks/useCountdown';
import { HALLOWEEK_DATES, HALLOWEEK_LAUNCH_AT } from '../data/halloweek';
interface HalloweekBannerProps {
  onOpen: () => void;
}
export function HalloweekBanner({
  onOpen
}: HalloweekBannerProps) {
  const reduceMotion = useReducedMotion();
  const countdown = useCountdown(HALLOWEEK_LAUNCH_AT);
  const pad = (n: number) => String(n).padStart(2, '0');
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onOpen();
  };
  return <motion.div initial={reduceMotion ? false : {
    height: 0
  }} animate={{
    height: 'auto'
  }} transition={{
    duration: 0.3,
    delay: 0.4,
    ease: [0.23, 1, 0.32, 1]
  }} className="halloween-theme relative z-50 w-full overflow-hidden bg-[#0E0C0B] border-b-4 border-[#FF7A1A]" data-id="element-585" data-mp="39hl61mmcuc1c">
      <a href="/events" onClick={handleClick} className="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#FF7A1A]" aria-label="Halloweek på Top Notch – se schema och boka" data-id="element-586" data-mp="1r8laniq909wh">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 md:py-3.5 flex items-center justify-between gap-4" data-id="element-587" data-mp="207q78ji91t60">
          <div className="flex items-center gap-3 md:gap-5 min-w-0" data-id="element-588" data-mp="251kqxmxuu853">
            <span className="hidden sm:flex items-center gap-1 shrink-0" data-id="element-589" data-mp="29yb1juqw4bj4">
              <GhostIcon className="w-6 h-6 -rotate-12" data-id="element-590" data-mp="2ewus68gfibht" />
              <PumpkinIcon className="w-6 h-6" data-id="element-591" data-mp="2jx0o40tqek5p" />
            </span>
            <span className="halloween-display text-[#FF7A1A] text-3xl md:text-4xl leading-none shrink-0" data-id="element-592" data-mp="2jxijywchewd3">
              Halloweek
            </span>
            <span className="hidden md:block w-px h-6 bg-[#F5EDE3]/20" data-id="element-593" data-mp="pjhis4tglx9u" />
            <span className="hidden md:block text-sm font-semibold text-[#F5EDE3]/85 whitespace-nowrap" data-id="element-594" data-mp="plc6ts0125i5">
              {HALLOWEEK_DATES}
            </span>
            {!countdown.isDone && <span className="hidden lg:flex items-center gap-2 text-sm text-[#F5EDE3]/60 whitespace-nowrap" data-id="element-595" data-mp="1wxl13du7lud4">
                · Lanseras söndag 00:00 ·
                <span className="font-bold text-[#FFB27A] tabular-nums" data-id="element-596" data-mp="25x7zrrvk0m2h">
                  {countdown.days}d {pad(countdown.hours)}:
                  {pad(countdown.minutes)}:{pad(countdown.seconds)}
                </span>
              </span>}
          </div>

          <span className="inline-flex items-center gap-1.5 shrink-0 px-4 py-2 rounded-full bg-[#FF7A1A] text-[#1A0F08] text-sm font-bold group-hover:bg-[#FF9A4D] transition-colors whitespace-nowrap" data-id="element-597" data-mp="2avjeafwsnkr1">
            {countdown.isDone ? 'Boka din plats' : 'Se nedräkningen'}
            <ArrowRight className="w-4 h-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-598" data-mp="2knf9nj7hwwrk" />
          </span>
        </div>
      </a>
    </motion.div>;
}